import * as React from 'react';

import { StyledData } from './style';

interface TableHeaderProps {
  children: React.ReactNode;
}

const TableData: React.FC<TableHeaderProps> = ({ children }) => {
  return (
    <StyledData data-testid="table-data">
      <div>{children}</div>
    </StyledData>
  );
};

export default TableData;
